/**
 * Przelacznik wewnetrznego asystenta AI (WiseAi).
 * Ustaw w `.env`: REACT_APP_WISE_AI=true lub 1.
 *
 * true  -> chat uzywa endpointow `/api/ui/assistant-ai/*` w naszym backendzie
 *          (autoryzacja Bearer UiApi, sessionId propagowane jako query param)
 * false -> chat uzywa zewnetrznego serwisu Orion pod REACT_APP_CHAT_API_BASE_URL
 */
export const isWiseAiEnabled = (): boolean => {
  const v = process.env.REACT_APP_WISE_AI;
  return v === 'true' || v === '1';
};
